import { render, staticRenderFns } from "./StatsByPoints.vue?vue&type=template&id=707eff5b&scoped=true&"
import script from "./StatsByPoints.vue?vue&type=script&lang=ts&"
export * from "./StatsByPoints.vue?vue&type=script&lang=ts&"
import style0 from "./StatsByPoints.vue?vue&type=style&index=0&id=707eff5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707eff5b",
  null
  
)

export default component.exports